import { useState, useEffect } from "react";
import { fetchAccounts } from "../lib/api_routes/user";
import { getActiveAccountId, setActiveAccountId } from "../lib/activeAccount";

// Returns the active account (saved choice, else first) + list for the switcher
export function useAccountInfo() {
  const [accountInfo, setAccountInfo] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const result = await fetchAccounts();
        if (Array.isArray(result) && result.length > 0) {
          const savedId = Number(getActiveAccountId());
          const raw = result.find((a) => a.account_id === savedId) ?? result[0];
          setActiveAccountId(raw.account_id); // heals a stale/missing saved ID

          setAccounts(
            result.map((a) => ({ accountId: a.account_id, accountName: a.account_name }))
          );
          setAccountInfo({
            accountId: raw.account_id,
            accountName: raw.account_name,
            sector: raw.sector || "",
            editableSector: raw.editable_sector,
            haveL4: raw.have_l4,
            showSupplierFinder: raw.show_supplierfinder,
            showIterator: raw.show_iterator,
            showRedaction: raw.show_redaction,
            showTranslator: raw.show_translator,
            showChatBot: raw.show_chatbot,
            showAIToolkit: raw.show_ai_toolkit,
            showSupplierDemandConstants: raw.show_supplier_demand_constants,
            showSpend: raw.show_spend,
          });
        }
      } catch (error) {
        console.error("Error fetching account info:", error);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { accountInfo, accounts, loading };
}